import React from 'react';
import toast from 'react-hot-toast';
import { useSelector } from 'react-redux';
import useRouter from '../../hook/useRouter';
import { RootState, store } from '../../store';
import useShare from '../common/Share';

export const Title = () => {
    const l10n = useSelector((state: RootState) => state.main.l10n);
    const iteminfo = useSelector((state: RootState) => state.detail.itemInfo);
    const { changeParam } = useRouter([]);
    const { startShare, loading } = useShare();

    const onShare = () => {
        startShare({
            _apiPath: `${store.getState().main.config.apiDomain}/${store.getState().main.config.service}/v2.0/game/short`,
            _title: `${iteminfo?.enchantLevel ? `+${iteminfo?.enchantLevel} ` : ''}${iteminfo?.itemName}`,
            _callback: () => {
                toast.dismiss();
                toast(
                    (t) => (
                        <div className="toast-wrapper">
                            <span className="toast-title">{l10n['common.copiedurl']}</span>
                        </div>
                    ),
                    {
                        duration: 3000,
                        className: 'gameinfo-toast',
                        position: 'bottom-center',
                    }
                );
            },
        });
    };

    return (
        <div className="gameinfo-detail__title">
            <button className="btn-prev" onClick={() => window.History.back()}>
                Prev
            </button>
            <h2>{l10n['common.viewdetail']}</h2>
            <button className="btn-share" title="share" data-areas="시세_아이템상세_공유_클릭" onClick={onShare}></button>
            <button
                className="btn-close"
                onClick={() => {
                    document.querySelector('.gameinfo-detail__section')!.scrollTo({ top: 0 });
                    changeParam({ detail: '' });
                }}
            >
                close
            </button>
        </div>
    );
};
